import React from 'react';
import { Link } from 'react-router-dom';
import { DivideIcon as LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';

interface CTASectionProps {
  title: string;
  description: string;
  icon: LucideIcon;
  buttonText: string;
  buttonLink: string;
  imageUrl?: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  icon: Icon,
  buttonText,
  buttonLink,
  imageUrl
}) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className="card p-8 bg-gradient-to-br from-brand/5 to-background relative overflow-hidden group"
    >
      {imageUrl && (
        <div className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="relative">
        <div className="flex items-center gap-3 mb-4">
          <motion.div 
            whileHover={{ rotate: 12 }}
            className="p-2 bg-brand/10 rounded-lg"
          >
            <Icon className="w-6 h-6 text-brand" />
          </motion.div>
          <h2 className="text-2xl font-bold text-content-primary">{title}</h2>
        </div>
        <p className="text-content-secondary mb-6 max-w-2xl">{description}</p>
        <Link
          to={buttonLink}
          className="inline-flex items-center px-6 py-3 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors group-hover:scale-105 transition-transform"
        >
          {buttonText}
        </Link>
      </div>
    </motion.div>
  );
};

export default CTASection;